import { LanguageContext } from './core/locale/LanguageContext';
import { CurrentLocale, TextFetcherBuilder } from './core/locale';
import { useState } from 'react';
import { Locale } from './core/locale/types';
import { getBrandFromQueryParamOrClaimsOrHost } from './core/context/claims';
import { useAppContext } from './core/context';

type OuterAppProps = {
  children: React.ReactNode;
};
export const LanguageProvider = ({ children }: OuterAppProps) => {
  const [locale, setLocale] = useState<Locale>(CurrentLocale);
  const context = useAppContext();
  const brand = getBrandFromQueryParamOrClaimsOrHost(context.claims);

  const setDomLanguage = (locale: Locale) => {
    document.getElementsByTagName('html')[0].setAttribute('lang', locale.split('-')[0]);
  };
  const updateLocale = (locale: Locale) => {
    setLocale(locale);
    setDomLanguage(locale);
  };

  const { fetcher, countryLocalization } = TextFetcherBuilder(locale, brand);
  return (
    <LanguageContext.Provider
      value={{
        countryLocalization: countryLocalization,
        setLocale: updateLocale,
        locale: locale,
        getLocalizedText: fetcher,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
